<template>
  <b-tabs
    ref="rc-view-tabbar"
  >
    <b-tab>
      <template #title>
        <span>Linear Sections</span>
      </template>
      <div v-if="linear_sections.length > 0">
        <linear-sections
          :linear_sections="mapped_linear_sections"
          :city-list="cityList"
          :zone-list="zoneList"
        />
      </div>
      <div
        v-else
        class="d-flex justify-content-center align-items-center my-4 font-weight-bold"
      >
        This rate card has no linear sections
      </div>
    </b-tab>
    <b-tab>
      <template #title>
        <span>Bucket Sections</span>
      </template>
      <div v-if="bucket_sections.length > 0">
        <bucket-sections
          :bucket_sections="mapped_bucket_sections"
          :city-list="cityList"
          :zone-list="zoneList"
        />
      </div>
      <div
        v-else
        class="d-flex justify-content-center align-items-center my-4 font-weight-bold"
      >
        This rate card has no bucket sections
      </div>
    </b-tab>
  </b-tabs>
</template>

<script>

/* eslint-disable vue/prop-name-casing */
/* eslint-disable vue/require-valid-default-prop */
import {
  BTabs,
  BTab,
} from 'bootstrap-vue'
import LinearSections from '@/components/rate-card/table-components/LinearSections.vue'
import BucketSections from '@/components/rate-card/table-components/BucketSections.vue'

export default {
  components: {
    BTabs,
    BTab,
    LinearSections,
    BucketSections,
  },
  props: {
    linear_sections: {
      type: Array,
      default: [],
    },
    bucket_sections: {
      type: Array,
      default: [],
    },
    cityList: {
      type: Array,
      default: [],
    },
    zoneList: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      mapped_linear_sections: [],
      mapped_bucket_sections: [],
    }
  },
  watch: {
    linear_sections: {
      immediate: true,
      deep: true,
      handler() {
        this.mapSections()
      },
    },
    bucket_sections: {
      immediate: true,
      deep: true,
      handler() {
        this.mapSections()
      },
    },
  },
  methods: {
    mapSections() {
      const linearRows = [];
      (this.linear_sections || []).forEach(element => {
        const cities = Array.isArray(element.cities) ? element.cities : []
        cities.forEach(city => {
          linearRows.push({
            city,
            section_type: element.section_type,
            amount: element.amount,
            service_type_name: element.is_service_type ? (element.service_type_name || '') : 'Default',
          })
        })
      })
      const bucketRows = [];
      (this.bucket_sections || []).forEach(element => {
        const cities = Array.isArray(element.cities) ? element.cities : []
        cities.forEach(city => {
          bucketRows.push({
            city,
            section_type: element.section_type,
            amount: element.amount,
            service_type_name: element.is_service_type ? (element.service_type_name || '') : 'Default',
          })
        })
      })
      this.mapped_linear_sections = linearRows
      this.mapped_bucket_sections = bucketRows
    },
  },
}
</script>
